// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section[data-v-73f3b4ef]{position:relative;height:120px}main[data-v-73f3b4ef]{position:absolute;width:100%}.boxUp[data-v-73f3b4ef],main[data-v-73f3b4ef]{text-align:center}.boxUp[data-v-73f3b4ef]{font-size:2em;color:#fff;margin-top:-10px}.version[data-v-73f3b4ef]{left:10px}.powered[data-v-73f3b4ef],.version[data-v-73f3b4ef]{position:absolute;bottom:10px}.powered[data-v-73f3b4ef]{right:10px}", ""]);
// Exports
module.exports = exports;
